import { Component, OnDestroy } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ConstantsService } from './common/constants.service';
import { LoaderComponent } from './shared/loader/loader.component';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';

const domElementGetter = () => document.getElementById('releaseMgmt');

@Component({
    standalone: true,
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [CommonModule, LoaderComponent, RouterModule]
})
export class AppComponent implements OnDestroy {
  constructor(private readonly titleService: Title, private readonly constantsService: ConstantsService) {
    this.titleService.setTitle(this.constantsService.applicationName);
  }
  
  ngOnDestroy() {
    const element = domElementGetter();
    if (element != null) {
      element.innerHTML = '';
    }
  }
}
